import { memo } from 'react';
import { Alert, Box, Heading } from '@zillow/constellation-10';
import { ModalActions } from './PropertySection';
import type { YourRentalErrorDto } from '@zg-rentals/ts-your-rental-api-client';

const CONTENT = {
  TITLE: 'Your rental',
} as const;

type PropertySectionErrorProps = {
  addRentalModal?: React.ReactNode;
  error: YourRentalErrorDto;
};

const PropertySectionError = memo(({ addRentalModal, error }: PropertySectionErrorProps) => {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: 'default',
        width: '100%',
      }}
    >
      <Box
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Heading data-testid="Header-Title" fontFamily="heading" level={1} textStyle="heading-sm">
          {CONTENT.TITLE}
        </Heading>
        <ModalActions hasMultipleRentals={false} addRentalModal={addRentalModal} />
      </Box>
      <Alert tone="critical" css={{ width: '100%' }}>
        {error.message}
      </Alert>
    </Box>
  );
});

PropertySectionError.displayName = 'PropertySectionError';

export default PropertySectionError;
